import { FooterGrid } from "./styles";

export const DropdownFooter = (props) => {
  const { children, ...rest } = props;

  return (
    <FooterGrid container id="dropdown-footer" {...rest}>
      {children}
    </FooterGrid>
  );
};
